import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import tallyClientTotals from '../../../helpers/newClientSummaryTotals';
import NewClientSummary from '../NewClient/NewClientSummary';
import NewClientFormStep1 from '../NewClient/NewClientFormStep1';
import { EmptyState } from 'components';
import FormProvider from 'components/FormProvider/FormProvider';
import * as styles from './BillingDetail.scss';
import { changeField } from 'redux/modules/forms';
var EditPlan = (_dec = connect(function (state, props) {
  return {
    billingHistory: state.billing.billingHistory,
    organization: state.organization.current,
    theme: state.theme,
    formValues: state.forms.client_edit_billing,
    currentPlanTotals: props.partnerDetails && props.orgBillingConfig ? tallyClientTotals(props.partnerDetails, props.orgBillingConfig) : null
  };
}, {
  changeField: changeField
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(EditPlan, _Component);

  var _super = _createSuper(EditPlan);

  function EditPlan(props) {
    var _this;

    _classCallCheck(this, EditPlan);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCardFieldChange", function (e) {
      _this.setState(_defineProperty({}, e.target.id, e.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleStep1Change", function (key, sectionKey, value) {
      _this.props.changeField('client_edit_billing', [sectionKey, key].filter(function (k) {
        return k;
      }), value);
    });

    _this.state = {};
    return _this;
  }
  /** *********************************************************
   CUSTOM METHODS
   ***********************************************************/


  _createClass(EditPlan, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          billingHistory = _this$props.billingHistory,
          currentOrgBillingConfig = _this$props.orgBillingConfig,
          partnerDetails = _this$props.partnerDetails,
          clientDetails = _this$props.clientDetails,
          formValues = _this$props.formValues;
      var newTotals = formValues && partnerDetails && formValues.orgConfig ? tallyClientTotals(this.props.partnerDetails, formValues.orgConfig) : {};
      var hasPlan = billingHistory.findIndex(function (e) {
        return !!e.lineItems.length;
      }) !== -1;
      return /*#__PURE__*/React.createElement(FormProvider, {
        name: 'client_edit_billing',
        defaultState: {
          orgConfig: _objectSpread({}, this.props.orgBillingConfig),
          step: 1
        }
      }, /*#__PURE__*/React.createElement("span", null, formValues && formValues.step === 1 && /*#__PURE__*/React.createElement("div", {
        className: styles.editPlanWrap
      }, !this.props.cc && /*#__PURE__*/React.createElement(EmptyState, {
        text: "You do not have a saved Payment Source",
        iconName: "fa fa-credit-card",
        iconSize: "95px",
        style: {
          marginTop: 24
        },
        buttonLabel: "Add Payment Source",
        buttonOnClick: function buttonOnClick() {
          if (_this2.props.gotoAddCardModal) {
            _this2.props.gotoAddCardModal();
          }
        }
      }), this.props.cc ? [/*#__PURE__*/React.createElement("div", {
        className: styles.editPlanColWrap
      }, /*#__PURE__*/React.createElement(NewClientFormStep1, {
        setFormValue: this.handleStep1Change,
        formValues: formValues,
        contractInfo: partnerDetails,
        edit: true
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.editPlanColWrap
      }, currentOrgBillingConfig.billingMethod !== 'likeable_smb' && /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: this.props.partnerDetails,
        orgConfig: formValues ? formValues.orgConfig : null,
        totals: newTotals,
        edit: true
      }))] : null), formValues && formValues.step === 2 && /*#__PURE__*/React.createElement("div", {
        className: styles.editPlanWrap
      }, hasPlan && /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 44%',
          padding: '2%'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.summaryHeader
      }, "Current Billing Summary"), currentOrgBillingConfig.billingMethod !== 'likeable_smb' ? /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: this.props.partnerDetails,
        orgConfig: currentOrgBillingConfig,
        totals: this.props.currentPlanTotals,
        wrapStyle: {
          marginTop: 0
        },
        edit: true
      }) : /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          border: '1px solid black',
          padding: 12,
          borderRadius: 4
        },
        className: styles.summaryHeader
      }, "Ads budget:", ' ', this.props.currentPlanTotals ? this.formatCurrency(this.props.currentPlanTotals.adsBudget) : '', ' ')), hasPlan && /*#__PURE__*/React.createElement("div", {
        style: {
          alignItems: 'center',
          display: 'flex',
          flex: '0 0 10%',
          padding: '2%'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-arrow-circle-right",
        style: {
          fontSize: 48,
          color: this.props.theme.colors.secondaryColor
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: hasPlan ? {
          flex: '0 0 44%',
          padding: '2%'
        } : {
          flex: '0 0 48%',
          padding: '0 2%'
        }
      }, hasPlan && /*#__PURE__*/React.createElement("span", {
        className: styles.summaryHeader
      }, "New Billing Summary"), currentOrgBillingConfig.billingMethod !== 'likeable_smb' ? /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: this.props.partnerDetails,
        orgConfig: formValues ? formValues.orgConfig : null,
        totals: newTotals,
        wrapStyle: hasPlan ? {
          border: "3px solid ".concat(this.props.theme.colors.secondaryColor),
          marginTop: 0
        } : {},
        edit: hasPlan
      }) : /*#__PURE__*/React.createElement("span", {
        className: styles.summaryHeader,
        style: {
          display: 'block',
          border: '1px solid black',
          padding: 12,
          borderRadius: 4
        }
      }, "Ads budget: ", this.formatCurrency(formValues ? formValues.orgConfig.adsBudget : 0), ' '), hasPlan && /*#__PURE__*/React.createElement("div", {
        className: styles.boldText
      }, "Changes made will go into effect", ' ', this.props.billingHistory[this.props.billingHistory.length - 1].invoiceEndDate, ".")), !hasPlan && /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '0 0 48%',
          padding: '0 2%',
          marginTop: 40
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.newAdsPlanTitle
      }, "Confirmation"), /*#__PURE__*/React.createElement("div", {
        className: styles.newAdsPlanItem
      }, "Client will be billed $", newTotals.totalBilledToClient), /*#__PURE__*/React.createElement("div", {
        className: styles.newAdsPlanItem
      }, "Click Submit to create an ad plan for your client.")))));
    }
  }]);

  return EditPlan;
}(Component)) || _class);
export { EditPlan as default };